if (!customElements.get('sw-parallax-component')) {
  customElements.define(
    'sw-parallax-component',
    class ParallaxComponent extends HTMLElement {
      constructor () {
        super();
        this.observer = new IntersectionObserver(this.callback.bind(this), { threshold: 0.1 });
        this.target = this.querySelector('.sw-parallax-interaction-trigger');
        this.target = this.target ?? this;
      }

      callback (entries) {
        entries.forEach((entry) => {
          const description = this.querySelector('.sw-parallax-description');
          const left = this.querySelector('.sw-parallax-card-left');
          const right = this.querySelector('.sw-parallax-card-right');
          if (entry.isIntersecting) {
            description?.classList.add('animated');
            description?.classList.remove('animated-back');
            left?.classList.add('animated');
            left?.classList.remove('animated-back');
            right?.classList.add('animated');
            right?.classList.remove('animated-back');
          } else {
            description?.classList.add('animated-back');
            description?.classList.remove('animated');
            left?.classList.add('animated-back');
            left?.classList.remove('animated');
            right?.classList.add('animated-back');
            right?.classList.remove('animated');
          }
        });
      }

      connectedCallback () {
        this.observer.observe(this.target);
      }

      disconnectedCallback () {
        this.observer.unobserve(this.target);
      }
    },
  );
}
